import { useState } from 'react'

import { useOnClickedOutside } from './useOnClickedOutside'

export interface UseDropdownStateReturn {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  toggleDropdown: () => void
  closeDropdown: () => void
  dropdownRef: React.RefObject<HTMLDivElement | null>
}

export const useDropdownState = (): UseDropdownStateReturn => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = () => setIsOpen(!isOpen)
  const closeDropdown = () => setIsOpen(false)

  const dropdownRef = useOnClickedOutside<HTMLDivElement>(isOpen ? closeDropdown : false)

  return {
    isOpen,
    setIsOpen,
    toggleDropdown,
    closeDropdown,
    dropdownRef,
  }
}
